import React from 'react';
import PropTypes from 'prop-types';

import OverlayModal from 'dpl/components/OverlayModal';

import ApplicationEntryContainer from '../containers/ApplicationEntryContainer';

export default function Overlay({ onClose }) {
  return (
    <OverlayModal hideCloseButton onClose={onClose}>
      <ApplicationEntryContainer onCloseClick={onClose} />
    </OverlayModal>
  );
}

Overlay.propTypes = {
  onClose: PropTypes.func.isRequired
};
